export const contractAddress = {
  ETC: "0x8f098C4FB5dCB5642C993c5a013c42E8CC0D7e56",
  AVAX: "0xa9c8f4322d2d2afb10ba1e71771D8D0C9062B0B5",
  BSC: "0x3238DAE5cD500Ec7f6502EDb19FE15E3095FEf9d"
};


export  const  RPCList = {
  ETH:  "https://mainnet.infura.io/v3/",
  BSC: "https://bsc-dataseed1.binance.org",
  AVAX: "https://api.avax.network/ext/bc/C/rpc",
  MATIC: "https://rpc-mainnet.maticvigil.com/",
  ETC: "https://www.ethercluster.com/etc",
  BCH: "https://global.uat.cash/",
};


export const chainIds = {
    ETH: 1,
    BSC: 56,
    AVAX: 43114,
    MATIC: 137,
    ETC: 61,
    BCH: 10000,
 };
  
  
 export const Explorers = {
 
    ETH: "https://etherscan.io/",
    BSC: "https://bscscan.com/",
    AVAX: "https://cchain.explorer.avax.network/",
    MATIC: "https://explorer.matic.network/",
    ETC: "https://blockscout.com/etc/mainnet/",
    BCH: "https://global.uat.cash/",
    
 }
 
  export const networklabelsNames = {

    BSC: "BNB Smart Chain Mainnet",
    AVAX: "Avalanche Mainnet C-Chain",
    ETC: "Ethereum Classic Mainnet",
    
  }
  
  
  export const networkNativeCurrency = {

    BSC: { name: 'BNB', decimals: 18, symbol: 'BNB' },
    AVAX: { name: 'AVAX', decimals: 18, symbol: 'AVAX' },
    ETC: { name: 'ETC', decimals: 18, symbol: 'ETC' },
    
  }
  
  
 export const labelsNames = {
    ETH: "Ethereum",
    BSC: "BNB Chain",
    AVAX: "Avalanche",
    MATIC: "Polygon",
    ETC: "Ethereum Classic",
    BCH: "Bitcoin Cash",
  }
  
 export const networkNames = {
    ETH: "eth",
    BSC: "binance",
    AVAX: "avalanche",
    MATIC: "polygon",
    ETC: "etc",
    BCH: "bch",
  }
  
